"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNumberItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const FormNumberItemUncontrolled_1 = require("./FormNumberItemUncontrolled");
const FormNumberItem = ({ value, ...props }) => {
    const [fieldsProps, _, helpers] = (0, formik_1.useField)(props.name);
    const handleChange = (e) => {
        helpers.setValue(e.target.value);
    };
    return (0, jsx_runtime_1.jsx)(FormNumberItemUncontrolled_1.FormNumberItemUncontrolled, { ...props, value: fieldsProps.value, onChange: handleChange, onBlur: fieldsProps.onBlur });
};
exports.FormNumberItem = FormNumberItem;
